export const buildProvenance = { "commitHash": "3238e9f632afda1b7394954e224d7a905a7bf6c3", "branchName": "refs/heads/release/2024.3", "buildDate": "2024-10-03T17:08:52.982Z", "version": "2024.3.12802" };
